<template>
  <div>
    <div v-if="!isSubmitted">
      <div class="has-text-centered membership-header">
        <h1 class="is-size-5 has-text-weight-bold">{{ $t('title.forgotPassword') }}</h1>
        <h2 class="is-size-6">{{ $t('description.enterYourEmailToResetYourPassword') }} :</h2>
      </div>
      <form v-on:submit.prevent="onSubmit(email)">
        <b-field :type="{ 'is-danger': errors.has('email') }" :message="errors.first('email')">
          <b-input
            icon-pack="fas"
            icon="envelope"
            :placeholder="$t('validation.attributes.email')"
            v-model="email"
            name="email"
            v-validate="'required|email'"
          />
        </b-field>
        <div class="field is-grouped is-grouped-centered">
          <p class="control">
            <button class="button is-vcentered is-primary login-button">
              {{ $t('button.request') }}
            </button>
          </p>
          <p class="control">
            <router-link
              class="button is-grey is-vcentered is-outlined login-button"
              :to="{ name: 'login' }"
              >{{ $t('button.cancel') }}</router-link
            >
          </p>
        </div>
        <div class="has-text-centered">
          <router-link :to="{ name: 'signup' }">
            {{ $t('description.dontYouHaveAnAccountSignUpNow') }}
          </router-link>
        </div>
      </form>
    </div>
    <div v-else-if="isSubmitted">
      <div class="has-text-centered membership-header">
        <h1 class="is-size-5 has-text-weight-bold">
          {{ $t('description.passwordResetEmailSent') }}.
        </h1>
        <h2 class="is-size-6">{{ $t('description.checkYourEmailInbox') }}</h2>
      </div>
    </div>
  </div>
</template>

<script>
import { FORGOTPASSWORD } from '../../store/actions.type'

export default {
  data() {
    return {
      email: null,
      link: null,
      isSubmitted: false
    }
  },
  methods: {
    onSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$recaptcha('forgotpassword').then(token => {
            this.forgotPassword(this.email.toLowerCase(), token)
          })
        }
      })
    },
    forgotPassword(email, recaptchaToken) {
      const url = `${window.location.origin}/${this.$t('routes.user')}/${this.$t(
        'routes.resetPassword'
      )}`
      this.$store.dispatch(FORGOTPASSWORD, { email, url, recaptchaToken }).then(() => {
        this.isSubmitted = true
      })
    }
  }
}
</script>
